import { defineStore } from 'pinia'
import cranksetService from '@/service/cranksetService'

export const useCranksetStore = defineStore('cranksetStore', {
  state: () => ({
    filterLength: cranksetService.fetchAverageCrankset(),
  }),
  getters: {},
  actions: {},
})
